import { Accordion } from '@monorepo/shared/componentsV2/Accordion';
import { DatasetPropertyAncestor, isSingleItemArray } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  max-width: 640px;
  margin: 0 20px;
  overflow: hidden;
`;

const NodeContainer = styled.div`
  position: relative;
`;

const InheritanceMarker = styled.div`
  position: absolute;
  top: -20px;
  display: inline-block;
  width: 20px;
  height: 38px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-left: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-radius: 0 0 0 8px;
`;

const DescendentContainer = styled.div`
  display: inline-block;
  margin: 8px 24px;
`;

const NestedContainer = styled.div`
  margin-left: 16px;
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: 8px;
`;

function NestedPropertyAncestor({
  propertyAncestor,
}: {
  propertyAncestor: DatasetPropertyAncestor;
}) {
  let nodeContent: React.ReactNode;

  if (
    propertyAncestor.name === 'Period' &&
    isSingleItemArray(propertyAncestor.children)
  ) {
    nodeContent = (
      <DescendentContainer>{`Period.${propertyAncestor.children[0].name}`}</DescendentContainer>
    );
  } else if (propertyAncestor.children.length === 0) {
    nodeContent = (
      <DescendentContainer>{propertyAncestor.name}</DescendentContainer>
    );
  } else {
    nodeContent = (
      <NestedContainer>
        <StyledAccordion
          detailsContent={propertyAncestor.children.map((child) => (
            <NestedPropertyAncestor propertyAncestor={child} key={child.id} />
          ))}
          summaryContent={propertyAncestor.name}
          defaultExpanded
          variant="condensed"
        />
      </NestedContainer>
    );
  }

  return (
    <NodeContainer>
      <InheritanceMarker />
      {nodeContent}
    </NodeContainer>
  );
}

export function WorkflowOutputPreview({
  propertyAncestry,
}: {
  propertyAncestry: DatasetPropertyAncestor[];
}) {
  return (
    <RootContainer>
      {propertyAncestry.map((propertyAncestor) => (
        <NestedPropertyAncestor
          propertyAncestor={propertyAncestor}
          key={propertyAncestor.id}
        />
      ))}
    </RootContainer>
  );
}
